import React from 'react';
import SignatureManager from 'SignatureManager/index';
import withSignatures from 'SignatureManager/EnhanceSignatures';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StaticBuilderSignatureManagerPreviewButton from './PreviewButton';
import StaticBuilderSignatureManagerCreatorButtons from './CreatorButtons';

export class StaticBuilderSignatureManager extends React.Component {
  static handleImageClick(src, type, e) {
    // Prevent default form submit for self-serve
    e.preventDefault();
  }

  constructor(props) {
    super(props);
    this.isLoadFromSave = this.isLoadFromSave.bind(this);
    this.loadSavedSignature = this.loadSavedSignature.bind(this);
    this.loadSignedOutSignature = this.loadSignedOutSignature.bind(this);
  }

  componentDidMount() {
    const savedType = this.props.savedSignature.type;
    const savedUrl = this.props.savedSignature.url;
    const isSignatureManagerEmpty = !this.props.imageUrls.draw && !this.props.imageUrls.type;
    if (savedUrl !== this.props.imageUrls[savedType]) {
      this.loadSavedSignature();
    } else if (!savedUrl && isSignatureManagerEmpty) {
      this.loadSignedOutSignature();
    }

    if (this.props.signatureActions.isSaveButtonHidden) {
      this.props.signatureActions.closeCreatorAction();
    }
  }

  componentDidUpdate() {
    const isSignaturePresent = this.props.imageUrls.draw || this.props.imageUrls.type;
    if (isSignaturePresent && !this.props.isSignatureAdded) {
      this.props.setIsSignatureAdded(true);
    } else if (!isSignaturePresent && this.props.isSignatureAdded) {
      this.props.setIsSignatureAdded(false);
    }
  }

  loadSavedSignature() {
    const url = this.props.savedSignature.url;
    const type = this.props.savedSignature.type;
    if (this.props.imageUrls[type] !== url) {
      // save the props savedSignature into imageUrls redux state
      this.props.saveSingleSignature(url, type);
    }
  }

  loadSignedOutSignature() {
    const lastUsedUrl = this.props.lastUsedImageUrl;
    if (!window.User.isLoggedIn && lastUsedUrl) {
      const lastUsedType = this.props.lastUsedImageType;
      if (this.props.imageUrls[lastUsedType] !== lastUsedUrl) {
        // save the lastUsed image into imageUrls redux state
        // so that it shows in SignatureManager
        this.props.saveSingleSignature(lastUsedUrl, lastUsedType);
      }
    }
  }

  isLoadFromSave() {
    // if there is already a saved signature as a field value
    if (this.props.savedSignature.url) {
      return true;
    }

    // if there are two signatures we need to have only one load
    if (this.props.imageUrls.draw && this.props.imageUrls.type) {
      return true;
    }

    // if user is signed out and we have an image saved
    if (!window.User.isLoggedIn && this.props.lastUsedImageUrl) {
      return true;
    }

    return false;
  }

  render() {
    const isSignaturePresent = this.props.imageUrls.draw || this.props.imageUrls.type;
    const signatureManagerClassNames = classNames(
      'signature-mananger-container',
      {
        'signature-present': isSignaturePresent,
      },
    );

    // boolean to determine when we override the imageUrls to something saved elsewhere
    const loadFromSave = this.isLoadFromSave();

    return (
      <div key={this.props.key} className="control-group" id={`group_${this.props.key}`}>
        <div className={signatureManagerClassNames}>
          <SignatureManager
            {...this.props}
            afterSaveSignatureAction={this.props.onSign}
            buttonText={{
              type: 'Type with Keyboard',
              draw: 'Draw with Mouse',
            }}
            clearBtnText="Clear"
            closeCreatorAction={this.props.signatureActions.closeCreatorAction}
            creatorButtons={StaticBuilderSignatureManagerCreatorButtons}
            drawCreatorLabel="Draw your signature"
            loadFromSave={loadFromSave}
            imageClick={StaticBuilderSignatureManager.handleImageClick}
            isSelfServe={this.props.isSelfServe}
            isSingleSignatureMode
            openCreatorAction={this.props.signatureActions.openCreatorAction}
            preventFormSubmit
            previewButtons={StaticBuilderSignatureManagerPreviewButton}
            previewButtonProps={{ handleSignClick: StaticBuilderSignatureManager.handleImageClick }}
            sigPadHeight={115}
            sigPadWidth={330}
            typeCreatorLabel="Type your full name"
            types={{
              type: true,
              draw: true,
            }}
          />
        </div>
      </div>
    );
  }
}

StaticBuilderSignatureManager.propTypes = {
  isSelfServe: PropTypes.bool,
  key: PropTypes.string.isRequired,
  signatureActions: PropTypes.shape({
    openCreatorAction: PropTypes.func,
    closeCreatorAction: PropTypes.func,
    isSaveButtonHidden: PropTypes.bool,
  }).isRequired,
  imageUrls: PropTypes.shape({
    draw: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  isSignatureAdded: PropTypes.bool.isRequired,
  lastUsedImageType: PropTypes.string,
  lastUsedImageUrl: PropTypes.string,
  onSign: PropTypes.func.isRequired,
  savedSignature: PropTypes.shape({
    url: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  saveSingleSignature: PropTypes.func.isRequired,
  setIsSignatureAdded: PropTypes.func.isRequired,
};

StaticBuilderSignatureManager.defaultProps = {
  isSelfServe: false,
  lastUsedImageType: '',
  lastUsedImageUrl: '',
};


const StaticBuilderSignatureManagerContainer = withSignatures(StaticBuilderSignatureManager);

export default StaticBuilderSignatureManagerContainer;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderSignatureManager/index.jsx